import { render, staticRenderFns } from "./seeClassMinsManage.vue?vue&type=template&id=542cbfe7&scoped=true"
import script from "./seeClassMinsManage.vue?vue&type=script&lang=js"
export * from "./seeClassMinsManage.vue?vue&type=script&lang=js"
import style0 from "./seeClassMinsManage.vue?vue&type=style&index=0&id=542cbfe7&prod&lang=less"
import style1 from "./seeClassMinsManage.vue?vue&type=style&index=1&id=542cbfe7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542cbfe7",
  null
  
)

export default component.exports